import { z } from 'zod';
import {
  ReferralStoredDocumentsSchema,
  requiresReferralDocumentOfType,
} from '../ReferralDocumentsSchema';
import { ReferralDocumentType } from '../../enums';

// The documents of a referral from a generic organization: the shared typed
// array (PPL-3549), plus the member's signed consent every organization on
// the generic form has to attach.
export const ReferralGenericDocumentsSchema =
  ReferralStoredDocumentsSchema.refine(
    ...requiresReferralDocumentOfType(
      ReferralDocumentType.patientReferralConsent,
      'Consent form is required',
    ),
  );

export type ReferralGenericDocuments = z.infer<
  typeof ReferralGenericDocumentsSchema
>;
